import React from 'react';
import { Button } from '../buttons/Button';
import { StructuredModal } from './Modal';
import type { ModalProps } from '../../types/common';

export interface ConfirmationModalProps extends Omit<ModalProps, 'children'> {
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger' | 'warning' | 'success';
  onConfirm: () => void;
  onCancel?: () => void;
  loading?: boolean;
}

/**
 * Confirmation dialog modal for user actions
 * Used for destructive or important actions that require user confirmation
 */
export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  title = 'Confirm Action',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
  loading = false,
  ...props
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel?.();
    onHide();
  };

  const footer = (
    <div className="d-flex justify-content-end gap-2">
      <Button
        variant="secondary"
        onClick={handleCancel}
        disabled={loading}
      >
        {cancelText}
      </Button>
      <Button
        variant={confirmVariant}
        onClick={handleConfirm}
        loading={loading}
      >
        {confirmText}
      </Button>
    </div>
  );

  return (
    <StructuredModal
      show={show}
      onHide={onHide}
      title={title}
      footer={footer}
      centered
      {...props}
    >
      <p className="mb-0">{message}</p>
    </StructuredModal>
  );
};

export default ConfirmationModal;
